import {connect} from 'react-redux';
import {PageTour as Component} from '@learningblocks/storybook-components';
import {getStepIndex, getTour, getTourData} from './PageTour.selector';

function mapStateToProps(state, ownProps) {
  return {
    run: getTour(state),
    stepIndex: getStepIndex(state),
    steps: getTourData(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const PageTour = connect(mapStateToProps, mapDispatchToProps)(Component);
